export default __webpack_public_path__ + "static/media/JoyLangLogo.45ac4376.png";